import React from "react";
import { Button } from "@/components/ui/button";

export const CTABanner = ({ onConsult, onSample }) => {
  return (
    <section data-testid="cta-banner" className="py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="relative rounded-3xl overflow-hidden vc-gradient p-10 md:p-16 text-white">
          <div className="absolute inset-0 vc-noise opacity-20" />
          <div className="absolute -right-20 -top-20 w-80 h-80 rounded-full bg-white/10 blur-3xl" />
          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="font-mono-vc text-[11px] uppercase tracking-[0.25em] text-white/80 font-bold">
                Let&apos;s build it together
              </div>
              <h2 className="mt-3 font-display text-3xl md:text-5xl font-extrabold leading-[1.05]">
                Looking for customized disposable packaging solutions?
              </h2>
              <p className="mt-4 text-white/90 text-base md:text-lg max-w-2xl">
                Partner with VersaCorp to create sustainable, high-quality products that
                strengthen your brand identity.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
              <Button
                data-testid="cta-consult-btn"
                onClick={onConsult}
                className="rounded-full h-12 px-7 bg-white text-neutral-900 hover:bg-neutral-100 font-semibold border-0"
              >
                Get Free Consultation
              </Button>
              <Button
                data-testid="cta-sample-btn"
                onClick={onSample}
                variant="outline"
                className="rounded-full h-12 px-7 bg-transparent border-white text-white hover:bg-white/10 font-semibold"
              >
                Request Sample
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
